const DEFAULT_ACCEPT = '.pdf,.jpg,.jpeg,.png'
const GERMAN_EINVOICE_ACCEPT = '.pdf,.jpg,.jpeg,.png,.xml'

const KNOWN_IMPORT_ERROR_CODES = new Set([
  'missing_file',
  'unsupported_file_type',
  'analysis_failed',
  'workflow_start_failed',
  'import_job_not_found'
])

export const getPurchaseInvoiceImportCopyKeys = (isGermanBusiness: boolean) => ({
  uploadDescription: isGermanBusiness
    ? 'invoicing.purchaseInvoiceImport.uploadDescriptionGermanEinvoice'
    : 'invoicing.purchaseInvoiceImport.uploadDescription',
  supportedFileTypes: isGermanBusiness
    ? 'invoicing.purchaseInvoiceImport.supportedFileTypesGermanEinvoice'
    : 'invoicing.purchaseInvoiceImport.supportedFileTypes',
  accept: isGermanBusiness ? GERMAN_EINVOICE_ACCEPT : DEFAULT_ACCEPT
})

export const getImportErrorTranslationKey = (errorCode?: string, isGermanBusiness = false) => {
  switch (errorCode) {
    case 'missing_file':
      return 'invoicing.purchaseInvoiceImport.error.missing_file'
    case 'unsupported_file_type':
      return isGermanBusiness
        ? 'invoicing.purchaseInvoiceImport.error.unsupported_file_type_german_einvoice'
        : 'invoicing.purchaseInvoiceImport.error.unsupported_file_type'
    case 'analysis_failed':
      return 'invoicing.purchaseInvoiceImport.error.analysis_failed'
    case 'workflow_start_failed':
      return 'invoicing.purchaseInvoiceImport.error.workflow_start_failed'
    case 'import_job_not_found':
      return 'invoicing.purchaseInvoiceImport.error.importJobNotFound'
    default:
      return 'invoicing.purchaseInvoiceImport.error.unknown'
  }
}

export const resolveImportErrorMessage = (
  payload: { error_code?: string; error_message?: string } | undefined,
  isGermanBusiness: boolean,
  translate: (key: string) => string
) => {
  const errorCode = payload?.error_code
  if (errorCode && KNOWN_IMPORT_ERROR_CODES.has(errorCode)) {
    return translate(getImportErrorTranslationKey(errorCode, isGermanBusiness))
  }
  return (
    payload?.error_message || translate(getImportErrorTranslationKey(errorCode, isGermanBusiness))
  )
}
